// 搜索地区树
import { request } from '@blade/common';
const MAP_URL = '/api/map-management';
export const zoneTreeApi = (data) => request({
    url: '/api/map-management/api/v1/map/zone/tree',
    method: 'POST',
    data
});
// 地图数据
export const fetchMapDetail = (data) => request.post(`${MAP_URL}/api/v1/map/query/${data.zoneId}`, data);
export const fetchNewMapDetail = (data) => request.post(`${MAP_URL}/api/v1/map/component/query/map/component`, data);
export const getPieData = (id) => request
    .get(`/api/crowd-management/api/v1/crowd/realtime/query/zone/${id}`);
export const getPieDataByTask = (id) => request
    .get(`/api/crowd-management/api/v1/crowd/realtime/query/task/${id}`);
export const getCrowdtrend = (data) => request
    .post('/api/crowd-management/api/v1/crowd/history/getZoneQuantityTrend', data);
export const getCrowdtrendBytask = (data) => request
    .post('/api/crowd-management/api/v1/crowd/history/getTaskQuantityTrend', data);
export const getCardData = (data) => request
    .post('/api/crowd-management/api/v1/crowd/realtime/query/zone/card', data);
// 折线图--查询总体人群饱和度峰值-人群监测区域饱和度峰值
export const getTotalCrowdPeak = (data) => request.post('/api/crowd-management/api/v1/crowd/history/trend/prime', data);
// 饼图--查询总体人群饱和度峰值-人群监测区域饱和度峰值
export const getTotalCrowdPeakSaturation = (data) => request.post('/api/crowd-management/api/v1/crowd/history/pie/prime', data);
// 实时区域人数折线图,支持地图和任务,见：getCrowdtrend
// 查询所有任务的人数趋势-人群饱和度趋势
export const getTotalCrowdTaskTrend = (data) => request.post('/api/crowd-management/api/v1/crowd/history/task/trend/multitask/', data);
// 分页查询所有任务的人群监测区域数据
export const getCrowdTaskPageData = (data) => request.post('/api/crowd-management/api/v1/crowd/history/task/trend/pagelist', data);
/* 人群洞察api */
// 获取人流排名
export const getCrowdMultiTrendData = (data) => request.post('/api/crowd-management/api/v1/cl/page/multi/trend', data);
// 获取人流卡片数据
export const getCrowdMultiTrendCardData = (data) => request.post('/api/crowd-management/api/v1/cl/multi/device/trend', data);
// 人流趋势
export const getMultiTrend = (data) => request.post('/api/crowd-management/api/v1/cl/multi/trend', data);
// 实时数据
export const getRealtimeCount = (data) => request.post('/api/crowd-management/api/v1/cl/realtime/count', data);
export const getCrowdClTrendData = (data) => request.post('/api/crowd-management/api/v1/cl/trend', data);
export const getCrowdClMultiTrendData = (data) => request.post('/api/crowd-management/api/v1/cl/multi/trend', data);
export const getCrowdClvisitor = (data) => request.post('/api/cluster-management/api/v1/cluster/visitor/indicators', data);
export const getCrowdClvisitorTrend = (data) => request.post('/api/cluster-management/api/v1/cluster/visitor/trend', data);
export const getCrowdClPageTrend = (data) => request.post('/api/crowd-management/api/v1/cl/page/multi/trend', data);
export const getCrowdClexport = (data) => request.post('/api/crowd-management/api/v1/export', data);
// 人群Va
export const getListAllTags = () => request.post('/api/task-management/api/v1/virtual/zone/tag/list/all');
export const getTreeTags = () => request.post('/api/task-management/api/v1/virtual/zone/tag/tag/tree');
export const getCrowdVaTrend = (data) => request.post('/api/crowd-management/api/v1/virtualarea/multi/trend ', data);
export const getCrowdVapie = (data) => request.post('/api/crowd-management/api/v1/virtualarea/pie', data);
export const getCrowdVaPageTrend = (data) => request.post('/api/crowd-management/api/v1/virtualarea/page/multi/trend', data);
export const getVisitorAnalysis = (data) => request.post('/api/crowd-management/api/v1/unique/visitor/analysis', data);
export const fetchTaskRoi = (data) => request.post('/api/task-management/api/v1/task/zone/task/rois', data);
export const dashboardConfig = () => request({
    url: `/api/crowd-management/api/v1/dashboard/config`,
    method: 'GET'
});
export const fetchWeather = (data) => request.post('/api/user-management/api/v1/ums/weather', data);
// 设备视频预览
export const getVideoInfoApi = (deviceId) => request.get(`/api/camera-device-management/api/v1/devices/agg/device/${deviceId}/rtsp`);
// 获取排队洞察在岗离岗小人数量
export const getDutyNumberCountApi = () => request.get(`/api/queue-management/api/v1/queue/realtime/query/zone/offDuty`);
